export default {
  en: {
    CONFIRM_MESSAGE: 'Are you sure?',
  }
};